import React, { useState, useEffect, useContext } from 'react';
import useForceUpdate from '../../../common/hooks/useForceUpdate';
import { useSelector, useDispatch } from 'react-redux';
import useTranslate from '../../../common/hooks/useTranslate';
import { getSignRequirements } from '../../services/docuSignService';
import setImpersonationToLS from '../../../common/utility/setImpersonationToLS';
import LogoSize from '../../../common/services/config/brandingStore';
import FilterCtx from '../../../context/filterContext/filterCtx';
import { RootState } from '../../../redux/store';
import { IMPERSONATE, POPUP, DOCUSIGN } from '../../../redux/types';
import BrandingStore from '../../../common/services/config/brandingStore';

import { IImpersonate } from '../types/IImpersonate';

import { Link } from 'react-router-dom';
import Logo from '../../ui/logo/logo';
import UserIcon from '../../ui/userIcon/userIcon';
import ContactTooltip from '../../ui/contactTooltip/contactTooltip';
import ResponsiveNavigation from '../../ui/navigation/responsiveNavigation/responsiveNavigation';
import Icon from '../../ui/icon/icon';
import DocuSignDropdown from '../../docuSign/components/docuSignDropdown/docuSignDropdown';

import './topbar.scss';

const Topbar: React.FC = () => {
  const [contactToggle, setContactToggle] = useState<boolean>(false);
  const [signData, setSignData] = useState<any[]>([]);
  const [additionalInfoTooltip, setAdditionalInfoTooltip] = useState<boolean>(false);
  const [responsiveNav, setResponsiveNav] = useState<boolean>(false);
  const [impersonate, setImpersonate] = useState<IImpersonate | undefined>({
    canImpersonate: false,
    impersonate: false,
    impersonateId: '',
    impersonateName: '',
  });

  const dispatch = useDispatch();
  const filterCtx: any = useContext(FilterCtx);
  const { t } = useTranslate();

  const impersonateRedux = useSelector((state: RootState) => state.impersonate);
  const docuSignDropdownRedux = useSelector((state: RootState) => state.docuSignDropdown.docuSignDropdown);
  const expanded = useSelector((state: RootState) => state.sidebar.expanded);

  const handleContactToggle = () => {
    setContactToggle(!contactToggle);
  };

  const responsiveNavId = 'ResponsiveNavId';
  const docuSignDropdownId = 'DocuSignDropdownId';
  const helpToolTipId = 'HelpToolTipId';
  const userIconId = 'userIconId';

  const impersonateClickHandler = () => {
    dispatch({ type: IMPERSONATE.IMPERSONATE_OFF });
    setImpersonationToLS('', '', '');
    filterCtx.clearAllFilters();
    useForceUpdate();
  };

  const getSignData = () => {
    getSignRequirements()
      .then((res) => {
        setSignData(res);
      })
      .then(() => {
        dispatch({ type: DOCUSIGN.SWITCH_DOCUSIGN_DROPDOWN });
      });
  };

  useEffect(() => {
    setImpersonate(impersonateRedux);
    getSignRequirements().then((res) => {
      setSignData(res);
    }).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
  }, [impersonateRedux]);

  return (
    <div className={`topbar-wrapper ${expanded === '1' ? 'expanded-sidebar-topbar-width' : ''}`}>
      <Logo logoSource='/branding/logo.png' height={`${LogoSize.logo_size}px`} />
      <div id={'right'}>
        {BrandingStore.kycUrl &&
          <a href={BrandingStore.kycUrl} target="_blank" onMouseOver={() => setAdditionalInfoTooltip(true)} onMouseLeave={() => setAdditionalInfoTooltip(false)}><Icon name='fas fa-id-badge' className='id-badge-icon' /></a>
        }
        {additionalInfoTooltip && <div className='additional-info-tooltip'>
          <p className='info'>
            {t('NAVIGATION.KYC_URL_INFO')}
          </p>
        </div>}
        {signData && signData.length > 0 && (
          <div className='docusign-topbar-wrapper hidden-mobile'>
            <div className='docusign-icon-wrapper pointer' id={docuSignDropdownId} onClick={getSignData}>
              <Icon name='fas fa-arrow-alt-to-bottom' className='docusign-icon' id={docuSignDropdownId} />
            </div>
            {docuSignDropdownRedux && <DocuSignDropdown signData={signData} id={docuSignDropdownId} />}
          </div>
        )}
        {impersonate.canImpersonate && (
          <Link to={'/impersonate'} className='impersonate-link'
                style={{ marginRight: impersonate && impersonate.impersonate === false && 25 }}>
            <Icon
              style={{ marginRight: impersonate && impersonate.impersonate === false ? 0 : 10 }}
              name={`${impersonate && impersonate.impersonate ? 'fas fa-masks-theater' : 'far fa-masks-theater'}`}
              className='impersonate-icon'
            />
            <span>{impersonate && impersonate.impersonate && `${impersonate.impersonateName}`}</span>
          </Link>
        )}
        {impersonate && impersonate.impersonate && impersonate.canImpersonate && (
          <Icon name='fas fa-xmark' className='impersonate-off-icon pointer' onClick={impersonateClickHandler} />
        )}
        <Icon id={responsiveNavId} name={`${responsiveNav ? 'fas fa-xmark' : 'fas fa-bars'}`} className='menu-icon pointer'
              onClick={() => setResponsiveNav(!responsiveNav)} />
        {responsiveNav && <ResponsiveNavigation setNav={setResponsiveNav} id={responsiveNavId} />}
        <div className='help-wrapper'>
          <Icon id={helpToolTipId} name='fas fa-question-circle' className='help-icon pointer' onClick={handleContactToggle} />
          {contactToggle && (
            <div className='contact-tooltip'>
              <ContactTooltip setTooltip={setContactToggle} id={helpToolTipId} />
            </div>
          )}
        </div>
        <UserIcon id={userIconId} />
      </div>
    </div>
  );
};

export default Topbar;
